import { stringify } from 'qs';
import request from '../../utils/request';

export async function detail(params){
  return request(`/api/blade-system/school-class-teacher/space-detail?${stringify(params)}`);
}

export async function statistics(params){
  return request(`/api/tscloud-statistics/school-famcous/teacher-teach-res?${stringify(params)}`);
}
